import Vue from 'vue'
import VueRouter from 'vue-router'
import Stepper from '../components/stepper/Index'
import Login from "@/components/Login";
import Success from "@/components/Success";
import Auth from "@/views/auth/Auth";
import Register from "@/components/Register";
import Profile from "@/components/Profile";
import Home from "@/views/Home";

Vue.use(VueRouter)

const routes = [
    {
        path: '/:lang',
        name: 'Submit',
        component: Home,
        children: [
            {
                path: '',
                name: 'Submit',
                meta: {title: 'Submit'},
                component: Stepper
            },
            {
                path: 'profile',
                name: 'Profile',
                meta: {title: 'Profile'},
                component: Profile
            },
            {
                path: 'success',
                name: '',
                component: Success
            }
        ]
    }, {
        path: '/auth/:lang',
        component: Auth,
        name: 'Auth',
        children: [
            {
                path: 'login',
                name: "Login",
                meta: {title: 'Login'},
                component: Login
            },
            {
                path: 'register',
                name: "Register",
                meta: {title: 'Register'},
                component: Register
            }
        ]
    }
]


const router = new VueRouter({
    base: process.env.VUE_APP_EXPORT_TYPE === 'application' ? '/' : '/if/panel/',
    mode: "history",
    routes
})


export default router
